import { DiGithubAlt } from "react-icons/di";
import { AiOutlineTwitter, AiFillSkype } from "react-icons/ai";
import { GrLinkedinOption } from "react-icons/gr";
import { FaHackerrank } from "react-icons/fa";

const data = [
  {
    icon: <GrLinkedinOption style={{ color: "#1DA1F2" }} />,
    link: "https://www.linkedin.com/in/ghulamazad",
  },
  {
    icon: <DiGithubAlt style={{ color: "#fff" }} />,
    link: "https://github.com/GhulamAzad",
  },
  {
    icon: <AiOutlineTwitter style={{ color: "#1DA1F2" }} />,
    link: "https://twitter.com/MdGhulamAzad",
  },
  {
    icon: <AiFillSkype style={{ color: "#00AFF0" }} />,
    link: "skype:live:md.ghulamazadansari_1?chat",
  },
];

export default data;
